import React from 'react';
import PropTypes from 'prop-types';

import { Group, LegalInfoWrapper, FormGroupWrapper, Label } from './Components';
import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import { copyFor, capitalization } from '../../copy/copy';

const OptInsAndButtonGroup = props => (
    <Group isSubmitting={props.isSubmitting}>
        {props.partnerOptIn && (
            <Label>
                {props.isEU
                    ? copyFor('formFields', 'updatesMultipleEU')
                    : copyFor(
                          'formFields',
                          'updates',
                          undefined,
                          capitalization.eachWord
                      )}
            </Label>
        )}
        <TwoGroup>
            {props.partnerOptIn && (
                <LegalInfoWrapper>
                    <FormGroupWrapper>
                        <GetUpdatesCheckbox
                            name="partnerOptIn"
                            labelText={props.partnerOptInText}
                            keepExistingCapitalization={true}
                        />
                    </FormGroupWrapper>
                    <FormGroupWrapper>
                        <GetUpdatesCheckbox
                            labelText={props.getUpdatesText || 'Action Button'}
                            keepExistingCapitalization={true}
                        />
                    </FormGroupWrapper>
                </LegalInfoWrapper>
            )}
            {!props.partnerOptIn && (
                <LegalInfoWrapper>
                    <FormGroupWrapper>
                        <GetUpdatesCheckbox
                            isEU={!!props.isEU}
                            labelText={props.getUpdatesText}
                        />
                    </FormGroupWrapper>
                </LegalInfoWrapper>
            )}
            <Button
                primary={true}
                label={props.buttonText}
                type="submit"
                className="submitButton"
                isSubmitting={props.isSubmitting}
                disabled={props.invalid}
            />
            <LoadingSpinner />
        </TwoGroup>
    </Group>
);

OptInsAndButtonGroup.propTypes = {
    buttonText: PropTypes.string.isRequired,
    getUpdatesText: PropTypes.string,
    invalid: PropTypes.bool,
    isEU: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool,
    partnerOptIn: PropTypes.bool.isRequired,
    partnerOptInText: PropTypes.string.isRequired
};

export default OptInsAndButtonGroup;
